import React, { Component, Fragment } from "react";
import { Paths } from "../../constants/UrlConstants";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { SilentRedirectToLogin } from "../../helpers/AccountsHelper";

export class IsUserLoggedIn extends Component {
  componentDidUpdate = () => {
    this.conditionallyRefreshOIDCUser();
  };

  componentDidMount = () => {
    this.conditionallyRefreshOIDCUser();
  };

  conditionallyRefreshOIDCUser = async () => {
    const { hasUserLoggedIn, hasUserExpired } = this.props;
    if (hasUserExpired && hasUserLoggedIn === null) {
      await SilentRedirectToLogin();
    }
  };

  render() {
    const { hasUserLoggedIn, children, history } = this.props;
    const handleUserStatusRedirect = () => {
      if (hasUserLoggedIn) {
        return children;
      } else if (hasUserLoggedIn !== null) {
        history.push(Paths.HomeRoot);
      }
    };

    return <Fragment>{handleUserStatusRedirect()}</Fragment>;
  }
}

export const mapStateToIsUserLoggedIn = ({ OIDCAccountReducer = {} }) => {
  return {
    hasUserLoggedIn: OIDCAccountReducer.hasUserLoggedIn,
    hasUserExpired: OIDCAccountReducer.hasUserExpired
  };
};

export default withRouter(connect(mapStateToIsUserLoggedIn)(IsUserLoggedIn));
